export default {"src":"/_next/static/media/tag-chocolate.26d7abe0.svg","height":20,"width":26,"blurWidth":0,"blurHeight":0};